import React from 'react'
import HomeBanner from '../component/Home/Banner'
import AboutTopArea from '../component/Home/AboutTop'
import AboutAres from '../component/Home/AboutArea'
import TrendingCauses from '../component/Home/TrendingCauses'
import EventArea from '../component/Home/EventArea'
import DonationArea from '../component/Home/Donation'
import PartnerArea from '../component/Home/Partner'
import CounterArea from '../component/Home/Counter'
import NewsAres from '../component/Home/NewsArea'
import WhoWeAre from '../component/Home/WhoWeAre'
import Many from '../component/Home/Many'
import Mission from '../component/Home/Mission'
import WhyWeExist from '../component/Home/WhyWeExist'
import WhatWeOffer from '../component/Home/WhatWeOffer'
import HeartbeatSection from '../component/Home/HeartbeatSection'
const Home = () => {
  return (
    <>       <HomeBanner/>
       <Many/>
       <WhoWeAre/>
       <Mission/>
       {/* <WhyWeExist/> */}
       <WhatWeOffer/>
       <HeartbeatSection/>
       {/* <DonationArea/> */}
    </>
  )
}

export default Home